module.exports = __webpack_public_path__ + "static/img/parking_equipment1_6.308c321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/parking_equipment1_6.jpg
// module id = CFKM
// module chunks = 0